import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { createClient } from '../utils/supabase/client';
import ApoelLogo from '../components/ApoelLogo'
import ApoelVisa from '../components/ApoelVisa'
import { formatDiagnosticsWithColorAndContext } from 'typescript';

const Dashboard = () => {
  const router = useRouter();
  const supabase = createClient();

  const [nationalID, setNationalID] = useState('');
  const [amountPaid, setAmountPaid] = useState('');
  const [receiptNumber, setReceiptNumber] = useState('');
  const [isAPOELVisa, setIsAPOELVisa] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');
  const [isIDChecked, setIsIDChecked] = useState(false);
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [customerID, setCustomerID] = useState(null);
  const [isSubmissionSuccessful, setIsSubmissionSuccessful] = useState(false);




  useEffect(() => {
    const checkAuth = async () => {
      const { data } = await supabase.auth.getSession();
      const session = data.session;

      if (!session || !session.user) {
        router.push('/login');
      }
    };

    checkAuth();
  }, [router, supabase]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !isIDChecked) {
      checkNationalID();
    }
  };

  const loginAndGetToken = async () => {
    try {
      const response = await fetch('/api/proxy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // other necessary headers...
        },
        body: JSON.stringify({
          email: 'loyalty@orangeshop.com',
          password: 'Loyalty-100100'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Received data:", data); // Log the data for debugging
      return data.data.token; // Adjusted to match the response structure
    } catch (error) {
      console.error('Login error:', error);
      return null;
    }
  };


  const checkNationalID = async () => {
    setError('');
    setFirstName('');
    setLastName('');
    setLoyaltyPoints(0);
    setIsLoading(true);

    const authToken = await loginAndGetToken();
    if (!authToken) {
      setError('Unable to obtain authentication token.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`/api/proxy2?NationalId=${nationalID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const customer = await response.json();

      if (customer) {
        setCustomerID(customer.data.customerId);
        setFirstName(customer.data.firstName);
        setLastName(customer.data.lastName);
        setIsIDChecked(true);
      } else {
        setError('No customer found with this National ID');
      }
    } catch (err) {
      setError('Failed to check National ID');
      console.error('Error:', err);
    }

    setIsLoading(false);
  };


  const calculatePoints = () => {
    const amount = Number(amountPaid); // Convert to number
    let points;

    // Round the division result to the nearest integer
    points = Math.round(amount / 5);

    return isAPOELVisa ? points * 2 : points; // Double the points if APOEL VISA is checked
  };


  const saveForm = async () => {
    setIsLoading(true);

    const parsedAmountPaid = Number(amountPaid); // Convert amountPaid to a number

    // Check if amountPaid is a positive number
    if (parsedAmountPaid <= 0) {
      setError('The amount paid must be a positive number.');
      setIsLoading(false);
      return;
    }

    if (!nationalID || !firstName || !lastName) {
      setError('Please fill in all required fields.');
      setIsLoading(false);
      return;
    }

    // Preparation of data to be inserted into proxy3/ticketing API
    const formData = {
      CustomerId: customerID,
      issueDate: new Date().toISOString(),
      description: `ORANGE SHOP PURCHASES P${receiptNumber}`,
      points: calculatePoints(),
    };

    // Data for Supabase insertion
    const reportData = {
      "National ID": nationalID,
      "Amount": parsedAmountPaid,
      "Receipt": receiptNumber,
      "Points Added": calculatePoints(),
      "APOEL Visa": isAPOELVisa,
    };

    console.log('Form Data:', formData);
    console.log('Report Data:', reportData);

    try {
      // Attempt to insert data via proxy3
      const response = await fetch('/api/proxy3', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await loginAndGetToken()}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      if (responseData.error) {
        throw new Error(responseData.error);
      }

      // // Success from proxy3, therefore insert into Supabase
      // const { data, error } = await supabase
      //   .from('loyaltyReport')
      //   .insert([reportData]);

      // if (error) {
      //   throw error;
      // }

      // console.log('Supabase Insertion Success:', data);
      
      setIsSubmissionSuccessful(true);
    } catch (error) {
      console.error('Error:', error);
      setError('Failed to save form.');
    // } finally {
      setIsLoading(false); // loading is false whether success or fail
    }
  };




  const resetForm = () => {
    setNationalID('');
    setFirstName('');
    setLastName('');
    setLoyaltyPoints(0);
    setIsIDChecked(false);
    setIsLoading(false);
    setError('');
    setIsSubmissionSuccessful(false);
    setCustomerID(null);
    setAmountPaid('');
    setReceiptNumber('');
    // Reset any other relevant states
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif' }}>
      {isSubmissionSuccessful ? (
        <div style={{ textAlign: 'center', maxWidth: '500px', padding: '20px' }}>
          <p>Form submitted successfully!</p>
          <button onClick={resetForm} style={{ padding: '10px', borderRadius: '4px', backgroundColor: '#008CBA', color: 'white', cursor: 'pointer' }}>
            New
          </button>
        </div>
      ) : (
        <div style={{ maxWidth: '500px', width: '100%', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center' }}><ApoelLogo /></div>
          <h1 style={{ textAlign: 'center', color: '#333' }}>ΑΠΟΕΛ LOYALTY</h1>
          <h4 style={{ textAlign: 'center', color: '#333' }}>ORANGE SHOP</h4>

          <input
            type="text"
            placeholder="National ID"
            value={nationalID}
            onChange={(e) => setNationalID(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={isIDChecked}
            style={{ width: '95.6%', padding: '10px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
          />


          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
            <button
              onClick={checkNationalID}
              disabled={isIDChecked}
              style={{ flex: 1, marginRight: '10px', padding: '10px', borderRadius: '4px', border: 'none', backgroundColor: '#f2b900', color: 'white', cursor: 'pointer' }}
            >
              Find Fan
            </button>

            {isIDChecked && (
              <button
                onClick={resetForm}
                style={{ paddingLeft: '10px', paddingRight: '10px', borderRadius: '4px', border: 'none', backgroundColor: '#008CBA', color: 'white', cursor: 'pointer', fontSize: '20px' }}
              >
                ↻
              </button>
            )}
          </div>

          <p style={{ color: 'red' }}>{error}</p>

          {isIDChecked && (
            <>
              <p><strong>Fan Name: {firstName} {lastName}</strong> </p>
              {/* <p>Current Loyalty Points: {loyaltyPoints}</p> Displaying the loyalty points */}

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ddd' }}>
                <span style={{ padding: '10px', backgroundColor: '#f0f0f0', color: '#333', borderRight: '1px solid #ddd' }}>€</span>
                <input
                  type="number"
                  placeholder="Amount Paid"
                  value={amountPaid}
                  onChange={(e) => setAmountPaid(e.target.value)}
                  style={{ flex: 1, padding: '10px', border: 'none', borderRadius: '0 4px 4px 0' }}
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ddd' }}>
                <span style={{ padding: '10px', backgroundColor: '#f0f0f0', color: '#333', borderRight: '1px solid #ddd' }}>P</span>
                <input
                  type="number"
                  placeholder="Receipt Number"
                  value={receiptNumber}
                  onChange={(e) => setReceiptNumber(e.target.value)}
                  style={{ flex: 1, padding: '10px', border: 'none', borderRadius: '0 4px 4px 0' }}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', width: 'auto', padding: '15px' }}>
                <div onClick={() => setIsAPOELVisa(!isAPOELVisa)} style={{
                  textAlign: 'center',
                  cursor: 'pointer',
                  border: isAPOELVisa ? '2px solid #0047AB' : 'none', // Border here
                  padding: '5px', // Padding here
                  display: 'inline-block', // To maintain proper layout
                  borderRadius: '4px' // Optional: if you want rounded corners
                }}
                >
                  <ApoelVisa
                    style={{
                      opacity: isAPOELVisa ? 1 : 0.5
                    }} />
                </div>
              </div>

              <button
                onClick={saveForm}
                disabled={!amountPaid || !receiptNumber || isLoading}
                style={{ width: '100%', padding: '10px', borderRadius: '4px', border: 'none', backgroundColor: '#008CBA', color: 'white', cursor: 'pointer' }}
              >
                {isLoading ? 'Processing...' : `Add ${calculatePoints()} Loyalty Points`}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}


export default Dashboard;
